<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.APIAccess.title") }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-row>
        <v-col cols="12" lg="6">
          <v-card-text>
            {{ $t("viewSettings.APIAccess.public_api_key_def") }}
            <v-text-field
                v-model="public_api_key"
                ref="textToCopy"
                outlined
                hide-details
                append-icon="fa-clipboard"
                @click:append="copyText"
                @click="copyText"
                :readonly="true"
                :loading="savingInProgress || !fetched"
            ></v-text-field>
            <v-btn @click="generate" class="mt-2" color="primary" elevation="0" :disabled="savingInProgress || !fetched">
              {{ $t("common.generate") }}</v-btn>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  data: () => ({
    key: "",
    isDisabled: true,
  }),
  mounted() {
    this.$store.dispatch('shops/getPublicApiKey')
  },
  created() {
    this.key = this.authenticatedUser.shop.public_api_key;
  },
  computed: {
    ...mapFields("auth", ["authenticatedUser"]),
    ...mapFields("shops", ["savingInProgress", "fetched", "public_api_key"]),
  },
  methods: {
    generate() {
      this.$confirm({
        title: this.$t("common.confirm"),
        text: this.$t("viewSettings.APIAccess.confirm_generate_public_api_key"),
        cancelText: this.$t("common.no"),
        acceptText: this.$t("common.yes"),
      }).then((y) => {
        this.$store.dispatch('shops/generatePublicApiKey');
      })
    },
    copyText() {
      this.isDisabled = false;
      this.$nextTick(() => {
        let textToCopy = this.$refs.textToCopy.$el.querySelector("input");
        textToCopy.select();
        document.execCommand("copy");
        this.isDisabled = true;
      });
    },
  },
};
</script>

<style scoped></style>
